export const formatRows = (listaItems) => 
  listaItems.map((item) => ({
    id: item.id || "Id no disponible",
    pcia_codigo: item.pcia_codigo || "Codigo no disponible",
    pcia_descripcion: item.pcia_descripcion || "Descripción no disponible",    
    mostrar: item.pcia_show_web === 0 ? "Visible" : "Oculto"
  }));

  